const { default: Styled } = require('styled-components');
const { default: InputLabel } = require('@mui/material/InputLabel');

const internals = {};
const LABEL_COLOR = '#12274f';

module.exports = function SelectFormControl(props) {

    const { StyledInputLabel } = internals;
    const {
        style,
        sx,
        ...rest
    } = props;

    return (
        <StyledInputLabel
            {...rest}
            style={{
                ...style,
                color: LABEL_COLOR
            }}
            sx={{
                ...(sx || {}),
                color: LABEL_COLOR,
                '&.Mui-focused': {
                    ...(sx?.['&.Mui-focused'] || {}),
                    color: LABEL_COLOR
                },
                '&.Mui-disabled': {
                    ...(sx?.['&.Mui-disabled'] || {}),
                    color: LABEL_COLOR
                }
            }}
        />
    );
};

internals.StyledInputLabel = Styled(InputLabel)`
    width: 100%;
    padding: 10px 0 !important;
    color: ${LABEL_COLOR} !important;
`;
